import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './comm/home/home.component';
import { UserRelationshipComponent } from './comm/user-relationship/user-relationship.component';
import { UserComponent } from './comm/user/user.component';
import { AccuseComponent } from './comm/accuse/accuse.component';
import { AppinfoComponent } from './comm/appinfo/appinfo.component';
import { SettingComponent } from './comm/setting/setting.component';
import { CheckinfoComponent } from './comm/checkinfo/checkinfo.component';
import { ProfileComponent } from './comm/profile/profile.component';
import { SigninComponent } from './comm/signin/signin.component';
import { RanklistComponent } from './comm/ranklist/ranklist.component';
import { NewPushlistComponent } from './comm/new-pushlist/new-pushlist.component';
import { LotteryComponent } from './comm/lottery/lottery.component';
import { FakeComponent } from './comm/fake/fake.component';
import { SmsRecodeComponent } from './comm/sms-recode/sms-recode.component';
import { BenefitsComponent } from './comm/benefits/benefits.component';
import { SudgameComponent } from './comm/sudgame/sudgame.component';

import { BanktransferComponent } from './comm/banktransfer/banktransfer.component';
import { WithdrawrecordComponent } from './comm/withdrawrecord/withdrawrecord.component';
import { AnnouncementComponent } from './comm/announcement/announcement.component';
import { AgentsetingComponent } from './comm/agentseting/agentseting.component';
import { OtagentsetingComponent } from './comm/otagentseting/otagentseting.component';
// agentfamily / ot-agentfamily 已改為 lazy module（*.lazy.module.ts）
import { AgentmemberComponent } from './comm/agentmember/agentmember.component';
import { GmComponent } from './comm/gm/gm.component';
import { GametopicComponent } from './comm/gametopic/gametopic.component';
import { ChattemplateComponent } from './comm/chattemplate/chattemplate.component';
import { UseractiveComponent } from './comm/useractive/useractive.component';
import { PushlistComponent } from './comm/pushlist/pushlist.component';
import { RewardofficalComponent } from './comm/rewardoffical/rewardoffical.component';
import { ShortlinkComponent } from './comm/shortlink/shortlink.component';
import { BlacklistComponent } from './comm/blacklist/blacklist.component';
import { TradelistComponent } from './comm/tradelist/tradelist.component';
import { ActiveComponent } from './comm/active/active.component';
import { StatisticsComponent } from './comm/statistics/statistics.component';
import { StatisticesComponent } from './comm/statistices/statistices.component';
import { MassSendingComponent } from './comm/masssending/masssending.component';
import { Community_sysComponent } from './comm/community_sys/community_sys.component';
import { UserlvComponent } from './comm/userlv/userlv.component';
import { ManualtitleComponent } from './comm/manualtitle/manualtitle.component';
import { LiveComponent } from './comm/live/live.component';
import { ReferralComponent } from './comm/referral/referral.component';
import { StorywallComponent } from './comm/storywall/storywall.component';
import { StoryactiveComponent } from './comm/storyactive/storyactive.component';
import { StableComponent } from './comm/stable/stable.component';
import { MsgreturnComponent } from './comm/msgreturn/msgreturn.component';
import { FindsthComponent } from './comm/findsth/findsth.component';
import { VoicelistComponent } from './comm/voicelist/voicelist.component';
import { SyssettingComponent } from './comm/syssetting/syssetting.component';
import { CustomervalueComponent } from './comm/customervalue/customervalue.component';
import { AdminreviewComponent } from './comm/adminreview/adminreview.component';
import { TagsystemComponent } from './comm/tagsystem/tagsystem.component';
import { PromotionRecordComponent } from './comm/promotion-record/promotion-record.component';
// otagentmember / otagentmemberbymobile 已改為 lazy module（*.lazy.module.ts）
import { LogviewComponent } from './comm/logview/logview.component';
import { UserPermissionComponent } from './comm/user-permission/user-permission.component';
import { GiftComponent } from './comm/gift/gift.component';
import { BagitemComponent } from './comm/bagitem/bagitem.component';
import { VideoComponent } from './comm/video/video.component';

import { MemberUplineComponent } from './comm/member-upline/member-upline.component';
import { HighRiskChurnComponent } from './comm/high-risk-churn/high-risk-churn.component';
import { UserBehaviorComponent } from './comm/user-behavior/user-behavior.component';
import { StudioMemberComponent } from './comm/studio-member/studio-member.component';

const routes: Routes = [
  // { path: '', redirectTo: 'signin', pathMatch: 'full'},
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  { path: 'otagentmember', loadChildren: () => import('./comm/otagentmember/otagentmember.lazy.module').then(m => m.OtagentmemberLazyModule) },
  { path: 'relationship', component: UserRelationshipComponent },
  { path: 'tagsys', component: TagsystemComponent },
  { path: 'promotion', component: PromotionRecordComponent },
  { path: 'accuse', component: AccuseComponent },
  { path: 'appinfo', component: AppinfoComponent },
  { path: 'blacklist', component: BlacklistComponent },
  { path: 'setting', component: SettingComponent },
  { path: 'user/:id/:profile', component: UserComponent },
  { path: 'user/:id', component: UserComponent },
  { path: 'user', component: UserComponent },
  { path: 'useractive/:id/:view', component: UseractiveComponent },
  { path: 'useractive/:id', component: UseractiveComponent },
  { path: 'useractive', component: UseractiveComponent },
  { path: 'checkinfo/:id', component: CheckinfoComponent },
  { path: 'checkinfo', component: CheckinfoComponent },
  { path: 'profile', component: ProfileComponent },
  { path: 'ranklist', component: RanklistComponent },
  { path: 'newPushlist', component: NewPushlistComponent },
  { path: 'lottery', component: LotteryComponent },
  { path: 'fake', component: FakeComponent },
  { path: 'smsrecode', component: SmsRecodeComponent },
  { path: 'smsrecode/:act', component: SmsRecodeComponent },
  { path: 'benefits', component: BenefitsComponent },
  { path: 'zegolist', loadChildren: () => import('./comm/zego-list/zego-list.lazy.module').then(m => m.ZegoListLazyModule) },
  { path: 'zego', loadChildren: () => import('./comm/zego/zego.lazy.module').then(m => m.ZegoLazyModule) },
  { path: 'sudgame', component: SudgameComponent },
  { path: 'zegochat', loadChildren: () => import('./comm/zego-chat/zego-chat.lazy.module').then(m => m.ZegoChatLazyModule) },
  { path: 'zegoplus', loadChildren: () => import('./comm/zego-chatplus/zego-chatplus.lazy.module').then(m => m.ZegoChatplusLazyModule) },

  { path: 'signin/:uToken', component: SigninComponent },
  { path: 'signin', component: SigninComponent },
  { path: 'login', component: SigninComponent },
  { path: 'banktransfer', component: BanktransferComponent },
  { path: 'withdrawal', component: WithdrawrecordComponent },
  { path: 'announcement', component: AnnouncementComponent },
  { path: 'report', loadChildren: () => import('./comm/report/report.lazy.module').then(m => m.ReportLazyModule) },
  { path: 'agentmember', component: AgentmemberComponent },
  { path: 'agentmember/:vid', component: AgentmemberComponent },
  { path: 'agentmember/:vid/:mid', component: AgentmemberComponent },
  { path: 'agentlist', loadChildren: () => import('./comm/agentfamily/agentfamily.lazy.module').then(m => m.AgentfamilyLazyModule) },
  { path: 'otagentlist', loadChildren: () => import('./comm/ot-agentfamily/ot-agentfamily.lazy.module').then(m => m.OtAgentfamilyLazyModule) },
  { path: 'agentseting', component: AgentsetingComponent },
  { path: 'agentseting/:vid', component: AgentsetingComponent },
  { path: 'agentseting/:vid/:mid', component: AgentsetingComponent },
  { path: 'otagentseting', component: OtagentsetingComponent },
  { path: 'otagentseting/:vid', component: OtagentsetingComponent },
  { path: 'otagentseting/:vid/:mid', component: OtagentsetingComponent },
  { path: 'gm', component: GmComponent },
  { path: 'gametopic', component: GametopicComponent },
  { path: 'chattemplate', component: ChattemplateComponent },
  { path: 'pushlist', component: PushlistComponent },
  { path: 'rewardoffical', component: RewardofficalComponent },
  { path: 'shortlink', component: ShortlinkComponent },
  { path: 'tradelist/:id/:action', component: TradelistComponent },
  { path: 'tradelist/:id', component: TradelistComponent },
  { path: 'tradelist', component: TradelistComponent },
  { path: 'active', component: ActiveComponent },
  { path: 'statistics', component: StatisticsComponent },
  { path: 'statistics/:timeinfo', component: StatisticsComponent },
  { path: 'statistices', component: StatisticesComponent },
  { path: 'statistices/:timeinfo', component: StatisticesComponent },
  { path: 'masssending', component: MassSendingComponent },
  { path: 'community_sys', component: Community_sysComponent },
  { path: 'userlv', component: UserlvComponent },
  { path: 'manualtitle', component: ManualtitleComponent },
  { path: 'live', component: LiveComponent },
  { path: 'referral/:id', component: ReferralComponent },
  { path: 'referral', component: ReferralComponent },
  { path: 'storywall', component: StorywallComponent },
  { path: 'storyactive', component: StoryactiveComponent },
  { path: 'stable', component: StableComponent },
  { path: 'msgreturn', component: MsgreturnComponent },
  { path: 'findsth', component: FindsthComponent },
  { path: 'voicelist', component: VoicelistComponent },
  { path: 'syssetting', component: SyssettingComponent },
  { path: 'customer_value', component: CustomervalueComponent },
  { path: 'admin_review', component: AdminreviewComponent },
  { path: 'otagentmemberbymobile', loadChildren: () => import('./comm/otagentmemberbymobile/otagentmemberbymobile.lazy.module').then(m => m.OtagentmemberbymobileLazyModule) },
  { path: 'logview', component: LogviewComponent },
  { path: 'userPermission', component: UserPermissionComponent },
  { path: 'gift', component: GiftComponent },
  { path: 'bagitem', component: BagitemComponent },
  { path: 'employee-auth', loadChildren: () => import('./comm/employee-auth/employee-auth.module').then(m => m.EmployeeAuthModule) },
  { path: 'video', component: VideoComponent },
  { path: 'member-upline', component: MemberUplineComponent },
  { path: 'member-upline/:id', component: MemberUplineComponent },
  { path: 'high_risk_churn', component: HighRiskChurnComponent },
  { path: 'user_behavior', component: UserBehaviorComponent },
  { path: 'studiomember', component: StudioMemberComponent },




];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
